module.exports = __webpack_public_path__ + "img/productManage.94889a08.svg";